var BulkAddToMemberStrings = {
    collectAndAddEmails: {
        title: function () { return 'Add Members'; },
        bodyText: function (n) {
            return "Enter the email address of each member separated by commas, newlines or spaces. You can add up to " + n + " members at a time. ";
        },
        button: {
            primaryText: function () { return 'Add'; },
            secondaryText: function () { return 'Cancel'; },
        },
        placeholderEmails: function () {
            return 'person1@company.com, person2@company.com, person3@company.com';
        },
        notValidEmailFormat: {
            singleFail: function (emailsString) {
                return emailsString + " is not a valid email address.";
            },
            multipleFail: function (emailsString) {
                return emailsString + " are not valid email addresses.";
            },
        },
        exceedEmailLimit: {
            singleFail: function (limit, numOfEmailToRemove) {
                return "You have exceeded the limit of " + limit + " email addresses. Please remove " + numOfEmailToRemove + " email address to continue.";
            },
            multipleFail: function (limit, numOfEmailToRemove) {
                return "You have exceeded the limit of " + limit + " email addresses. Please remove " + numOfEmailToRemove + " email addresses to continue.";
            },
        },
        fieldIsRequired: 'Field is required.',
    },
    confirmAddEmailsToTeamAndGroup: {
        title: {
            singleNotExisting: function () { return "1 Person Is Not An Existing Employee"; },
            multipleNotExisting: function (n) {
                return n + " People Are Not Existing Employees";
            },
        },
        bodyText: {
            singleAdd: function (teamAccountName, groupName) {
                return "The following person is not an existing member of " + teamAccountName + " yet. Do you want to add this person to the team account " + teamAccountName + " and the group " + groupName + "?";
            },
            multipleAdd: function (n, teamAccountName, groupName) {
                return "The following " + n + " people are not existing members of " + teamAccountName + " yet. Do you want to add them to the team account " + teamAccountName + " and the group " + groupName + "?";
            },
        },
        button: {
            primaryText: function () { return 'Add'; },
            secondaryText: function () { return 'Do Not Add'; },
        },
    },
    informUserCannotAddEmail: {
        tryAgain: function () { return "Please try again."; },
        button: {
            primaryText: function () { return 'Got It'; },
        },
        modal: {
            titleSingleFail: function () { return "1 person unable to be added to group"; },
            titleMultipleFail: function (n) {
                return n + " people unable to be added to group";
            },
        },
        addToGroup: {
            singleFail: function () {
                return "We encountered an error when adding the following person to the group.";
            },
            multipleFail: function (n) {
                return "We encountered errors when adding the following " + n + " people to the group.";
            },
        },
        inviteToTeamAccount: {
            singleFail: function () {
                return "The following person cannot be added because they have already been invited to another team.";
            },
            multipleFail: function (n) {
                return "The following " + n + " people cannot be added because they have already been invited to another team.";
            },
        },
    },
};
export default BulkAddToMemberStrings;
